export default __webpack_public_path__ + "assets/hr-video-placeholder.d9cf8653.jpg";